<template>
    <div class="opening-wrapper">

      <h1 id="opening-header">Aeroklub Kroměříž</h1>
      <div class="warning-wrapper-main">
        <the-warning :isClosable="true" />
      </div>
      <!-- <img src="../../src/assets/cover/img13.jpg" alt="" class="bg-black object-center object-cover absolute inset-0 h-full w-full"> -->
    </div>
</template>

<script>
import TheWarning from '../components/TheWarning.vue'

export default {
    name: "TheOpening",
    components: {
      TheWarning
    }
}
</script>


<style scoped>
img{
  position: absolute;
  object-fit: cover;
  width: 100%;
  height: 100%;
  max-height: 100%;
}

.warning-wrapper-main{
  position: absolute;
  bottom: 50px;
  z-index: 1000;
  width: 1285px;
  max-width: 90vw;
  margin: auto;

}

.opening-wrapper{
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  height: 100vh;
  width: 100%;

  background-image: url("../../src/assets/cover/img13.jpg");
  background-repeat:no-repeat;
  -webkit-background-size:cover;
  -moz-background-size:cover;
  -o-background-size:cover;
  background-size:cover;
  background-position: 60% center;
  /* background-position: center center;
  background-repeat: no-repeat; */
}
.group-btn{
  position: absolute;
  z-index: 950;
  bottom: 80px;

}
#opening-header{
  position: absolute;
  z-index: 10;
  font-size: 40px;
  color: aliceblue;
}
#btn-pridejse{

  font-size: 30px;
  opacity: 0.6;
  transition: 0.3s;
  background: rgb(65, 195, 255);
}
#btn-pridejse:hover{
  opacity: 1;
}
</style>